import styled from "styled-components";
import { Image } from "antd";
export const LineDisconnect = styled(Image)`
    width: 97px;
    display: block;
    position: absolute;
    top: 0;
    right: -6px;
    height: 20px;
`;